export default __webpack_public_path__ + "static/media/website_cover_mobimageZh.6b85a40b.jpg";